import { countries } from '#common/countries';

const shopSettingsCountries = Object.fromEntries(countries.map(c => [ c.code, c.en ]));

export default {
    common: {
        meta: {
            title: 'CrispyVoice',
            subTitle: 'Speaker Portal'
        },
        mediums: {
            commercials: 'Commercials',
            'info-videos': 'Info Videos',
            'social-media': 'Social Media',
            'e-learning': 'E-Learning',
            public: 'Public'
        },
        buttons: {
            cancel: 'Cancel',
            back: 'Back',
            submit: 'Submit'
        },
        errors: {
            somethingWentWrong: 'Something went wrong!'
        }
    },
    navigation: {
        title: 'CrispyVoice',
        subTitle: 'Speaker Portal',
        home: 'Dashboard',
        'clone-settings': 'Clone Settings',
        'shop-settings': 'Shop Settings',
        buyers: 'Buyers',
        sales: 'Sales',
        voices: 'My Voices',
        'speaker-settings': 'Speaker Settings',
        affiliate: 'CrispyAffiliate',
        account: 'Account',
        logout: 'Logout'
    },
    login: {
        meta: {
            title: 'Login',
            subTitle: 'CrispyVoice Speaker Portal'
        },
        email: 'E-Mail address',
        password: 'Password',
        'remember-me': 'remember me',
        login: 'Login',
        signIn: 'Sign In',
        forgotPassword: 'Forgot your password?',
        createAnAccount: 'Create an account!',
        resetPassword: 'Reset password',
        backToLogin: 'Back to Login',
        checkYourEmail: 'Check your email',
        emailVerificationCodeSent: "We've sent you a code to verify your email address.",
        newPassword: 'New Password',
        confirmNewPassword: 'Confirm New Password',
        check2faApp: 'Check your 2FA app',
        enter2faCode: 'Please enter your 2FA code to verify your identity.'
    },
    auth: {
        titles: {
            forgotPassword: 'Forgot password?',
            login: 'Login',
            register: 'Register',
            resetPassword: 'Reset password',
            verifyCode: 'Enter code'
        }
    },
    welcome: {
        welcome: 'Welcome to CrispyVoice!',
        greeting: "It's good to have you, {{user_name}}!",
        steps: {
            explanation: 'Before you can start using your clone, we need you to perform a few steps:',
            record: 'Record {{hours}} hours of your voice in studio quality',
            'upload-and-confirm': 'Upload and confirm your recordings in the <0>$t(navigation:clone-settings)</0>',
            'sit-back': 'Sit back and wait while we create your CrispyVoice. This will take a few days'
        },
        core: {
            explanation: 'To get started, please connect your ElevenLabs account:',
            'set-api-key': 'Enter your ElevenLabs API key in the <0>$t(navigation:clone-settings)</0>'
        }
    },
    dashboard: {},
    'creating-clone': {
        heading: 'Creating Clone...',
        subHeading:
            'We are currently creating your clone. This will take a few days, please wait. We will update you as soon as your clone is ready.',
        'setup-shop':
            "In the meantime, you can set up <0>your shop</0> so you can monetize your voice right after it's ready.",
        core: {
            heading: 'Set Up Your Voice',
            subHeading: 'Your ElevenLabs account is connected. Now create and configure your first voice.',
            'create-voice': 'Go to <0>$t(navigation:voices)</0> to create and configure your voice.'
        }
    },
    account: {
        heading: 'Account',
        name: 'Name',
        'name-change-successful': 'Name changed successfully!',
        language: 'Display language',
        save: 'Save',
        email: 'Email address',
        'change-email': 'Change email',
        'new-email': 'New email address',
        'email-change-successful': 'Email address changed successfully!',
        password: 'Password',
        'change-password': 'Change password',
        'current-password': 'Current password',
        'new-password': 'New password',
        'repeat-new-password': 'Repeat new password',
        'password-change-successful': 'Password changed successfully!',
        validation: {
            name: {
                required: 'Please enter a name'
            },
            email: {
                invalid: 'Please enter a valid email address',
                same: 'New email is the same as your current email',
                taken: 'This email address is already in use'
            },
            password: {
                currentRequired: 'Current password is required',
                repeatRequired: 'Please repeat your new password',
                mismatch: 'Passwords do not match',
                currentInvalid: 'Current password is incorrect'
            }
        },
        invoices: 'Invoices',
        'invoice-date': 'Date',
        'invoice-amount': 'Amount',
        'invoice-status': 'Status',
        'invoice-link': 'Invoice',
        'invoice-view': 'View',
        subscription: 'Subscription',
        'subscription-status': 'Status',
        'subscription-duration': 'Billing cycle',
        'subscription-duration-monthly': 'Monthly',
        'subscription-duration-yearly': 'Yearly',
        'subscription-renews-on': 'Renews on {{date}}',
        'subscription-minimum-contract-until': 'Minimum contract period until {{date}}',
        'subscription-cancels-on': 'Cancels at end of billing period on {{date}}',
        'subscription-cancel': 'Cancel Subscription',
        'subscription-cancel-confirm-title': 'Cancel Subscription?',
        'subscription-cancel-confirm-body':
            'Are you sure you want to cancel your subscription? Please review the details below before proceeding.',
        'subscription-cancel-effective-date': 'Your subscription will remain active until {{date}}.',
        'subscription-cancel-detail-access':
            'You will retain full access until the end of your current billing period.',
        'subscription-cancel-detail-reactivate': 'You can reactivate your subscription at any time before it expires.',
        'subscription-cancel-confirm-button': 'Yes, Cancel Subscription',
        'subscription-cancel-dismiss': 'No, Keep Subscription',
        'subscription-cancelSuccessful':
            'Your subscription has been set to cancel at the end of the current billing period.',
        'subscription-reactivate': 'Reactivate Subscription',
        'subscription-reactivateSuccessful': 'Your subscription has been reactivated successfully.',
        'stripe-connect-heading': 'Payouts',
        'stripe-connect-active': 'Your payouts are active.',
        'stripe-connect-pending': 'Your payout account has been created but setup is not yet complete.',
        'stripe-connect-not-connected': 'Set up payouts to receive your earnings from audio sales.',
        'stripe-connect-manage': 'Manage Payouts',
        'stripe-connect-setup': 'Set up Payouts',
        'stripe-connect-page-title': 'Stripe Connect',
        'stripe-connect-page-description': 'We use Stripe to send you your payouts when buyers purchase your audio.',
        'stripe-connect-status': 'Status',
        'stripe-connect-payouts': 'Payouts',
        'stripe-connect-payouts-enabled': 'Active',
        'stripe-connect-payouts-pending': 'Setup pending',
        'stripe-connect-active-since': 'Active since:',
        'stripe-connect-deauthorized-on': 'Deauthorized on:',
        'stripe-connect-no-account': 'No Stripe account connected.',
        'stripe-connect-product-description': 'AI-generated audio content via CrispyVoice',
        'stripe-connect-setup-title': 'Set Up Payouts',
        'stripe-connect-setup-description':
            "To receive your payouts, we'll create a dedicated Stripe account for your CrispyVoice earnings. You'll be guided through a short onboarding process by Stripe.",
        'stripe-connect-setup-button': 'Create Payout Account',
        'stripe-connect-setup-info':
            'We create a separate Stripe account exclusively for your CrispyVoice payouts. This protects your privacy — linking an existing Stripe account would require granting us full access to all your customers, transactions, and account data.',
        'stripe-connect-redirecting': 'Creating your payout account and redirecting to Stripe…',
        'stripe-connect-complete-title': 'Complete Setup',
        'stripe-connect-complete-description':
            'Your payout account has been created but setup is not yet complete. Continue where you left off to start receiving payouts.',
        'stripe-connect-complete-button': 'Continue Setup',
        'stripe-connect-link-expired': 'Your onboarding link expired. Click below to get a new one.',
        'stripe-connect-connected-title': 'Payouts Active',
        'stripe-connect-connected-description':
            "You're all set — your payouts are active. You can manage your payout details in the Stripe Dashboard.",
        'stripe-connect-open-dashboard': 'Open Stripe Dashboard',
        'stripe-connect-disconnect': 'Disconnect',
        'stripe-connect-disconnect-title': 'Disconnect Stripe Account?',
        'stripe-connect-disconnect-body':
            'Are you sure you want to disconnect your Stripe account? You will no longer receive direct payouts for audio sales.',
        'stripe-connect-disconnect-confirm': 'Yes, Disconnect',
        'stripe-connect-disconnect-cancel': 'No, Keep Connected',
        'stripe-connect-success': 'Your Stripe account has been connected successfully!',
        'stripe-connect-error-exchange-failed': 'Failed to connect your Stripe account. Please try again.',
        'stripe-connect-error-no-account-id': 'No Stripe account ID was returned. Please try again.',
        'stripe-connect-error-no-express-account':
            'No Express account found. Please start the onboarding process again.',
        'stripe-connect-reconnect-title': 'Reconnect Account',
        'stripe-connect-reconnect-description':
            'Your Express account still exists on Stripe. You can reconnect without re-entering your details.',
        'stripe-connect-reconnect-button': 'Reconnect Stripe Express',
        'stripe-connect-disconnected': 'Disconnected'
    },
    'clone-settings': {
        heading: '$t(navigation:clone-settings)',
        'already-confirmed':
            "You've confirmed your uploaded recordings on {{when, datetime}}. We are currently working on creating your clone.",
        'please-wait': 'This will take a few days, please stand by...',
        instructions:
            'Upload {{hours}} hours of recordings of your voice. Once you are satisfied with the uploaded files, confirm them to start the process of creating your clone.',
        explanation:
            'You can pause the upload of a file at any time, either by clicking the corresponding button or by navigating to another page or by closing your browser. To resume the upload of this file, select it again via "$t(recordings.select-file)".',
        dialogs: {
            confirm: {
                title: 'Confirm recordings?',
                body:
                    'Are you sure you want to confirm your recordings? This will start the process of creating your clone.',
                button: 'Confirm recordings'
            },
            delete: {
                title: 'Delete recording?',
                body: 'Are you sure you want to delete this recording?',
                button: 'Yes, delete'
            }
        },
        recordings: {
            filename: 'File name',
            'total-size': 'Total size',
            'uploaded-size': 'Already uploaded size',
            size: 'Size',
            progress: 'Progress',
            status: {
                title: 'Status',
                finished: 'Finished',
                uploading: 'Uploading',
                paused: 'Paused'
            },
            actions: {
                title: 'Actions',
                delete: 'Delete',
                pause: 'Pause',
                resume: 'Resume'
            },
            'select-file': 'Select file',
            confirm: 'Confirm & start clone creation'
        },
        errors: {
            'total-size': 'Cannot exceed {{size}} total.',
            'file-size': 'File is too large (over {{size}}).',
            'already-uploaded': 'This file has already been fully uploaded.'
        },
        core: {
            'section-title': 'ElevenLabs API Key',
            'section-description':
                'Enter your ElevenLabs API key to connect your account. You can change this at any time.',
            'api-key-placeholder': 'ElevenLabs API Key',
            'api-key-required': 'Please enter your API key.',
            'current-key': 'Current API key: {{key}}',
            'save-successful': 'API key saved successfully.',
            save: 'Save API Key',
            'form-dirty': 'You have unsaved changes.'
        },
        'audio-editing': {
            heading: 'Professional Audio Processing',
            description:
                'Want the best possible clone quality? Let CrispyVoice professionally process your recordings (mix & master). Without this service, we cannot guarantee the best possible sound quality for your clone voice.',
            cta: 'Book Audio Processing'
        }
    },
    'shop-settings': {
        heading: 'Shop Settings',
        subheading: 'Configure the details of your personal shop where your clients can buy your voice.',
        'voice-heading': 'Voice Settings',
        'voice-subheading': 'Configure this voice for your Unified Shop.',
        description:
            'Changes you save here will not be visible in your shop right away. Instead, you can first verify them in a preview version of the shop and then release them to your live version. See more at the end of this page.',
        sections: {
            slug: {
                title: 'Sub-domain',
                'title-single': 'Voice path',
                description: 'This is the sub-domain where we will host your shop.',
                'description-single': 'This is the URL path for this voice on your shop.',
                subdomain: 'Your shop domain: {{shopHost}}',
                'path-preview': 'Your voice URL: {{speakerHost}}/{{voiceSlug}}',
                warning:
                    "You can only set this once. After you've chosen your sub-domain, you can't change it anymore, so choose carefully.",
                readonly: "This setting can't be changed anymore after it has been saved.",
                'validation-format': 'Only a-z, 0-9 and - allowed. Must start with a letter.',
                'validation-min-length': 'At least 3 characters'
            },
            displayName: {
                title: 'Display name',
                description:
                    'Your name to display on your shop. Can be your full name, or whatever else your clients recognize you by',
                'unified-title': 'Voice name',
                'unified-description': 'The name of this voice as shown in your shop.'
            },
            voiceDescription: {
                title: 'Voice Description',
                description:
                    'A short description of your voice (max 300 characters). Displayed on the website below your name and above the voice comparison player.',
                placeholder: 'e.g. Warm, trustworthy voice — perfect for audiobooks and commercials',
                'placeholder-de': 'z.B. Warme, vertrauenswürdige Stimme — perfekt für Hörbücher und Werbung'
            },
            shopPassword: {
                title: 'Shop password',
                description:
                    'Optional password to protect your shop from unwanted visitors. If set, your clients will need to enter this password before they can see your shop. Clear the password to allow public access.',
                'description-set': 'Your shop is currently protected by a password.',
                'description-unset': 'Your shop is currently available to everyone.'
            },
            image: {
                title: 'Image',
                description:
                    'The image of you that we should display in your shop. It looks best with a transparent background',
                'current-image': 'Current image',
                'change-image': 'Change image',
                preview: 'Preview',
                'drop-or-click': 'Drop an image here or click to select one',
                'select-image': 'Select image',
                zoom: 'Zoom'
            },
            video: {
                title: 'Video',
                description: 'An optional video introducing yourself to your clients. Format: Square or Portrait.',
                'not-supported': 'Your browser does not support the video tag.',
                'change-video': 'Change video',
                remove: 'Remove',
                'drop-or-click': 'Drop a video here or click to upload',
                'max-size': 'Max file size: {{maxSize}} MB',
                'file-too-large': 'File is too large. Maximum size is {{maxSize}} MB.',
                'read-error': 'Error reading file'
            },
            'primary-voice': {
                title: 'Primary Voice',
                description: 'Select which of your voices is used for clone demo generation and shown on the website.'
            },
            audioSamples: {
                title: 'Voice Demos',
                description:
                    'Upload natural voice samples and generate clone voice demos. For the clone voice, enter the same text that is spoken in the natural voice demo.',
                'website-heading': 'Website Samples',
                'website-description':
                    'These samples are displayed on our website. Both voice samples must use the fixed text shown below.',
                'fixed-text-hint':
                    'Record your natural voice reading this exact text. The clone voice will generate it automatically.',
                'shop-heading': 'Speaker-Shop Samples',
                'shop-description':
                    'These samples are displayed in your speaker shop. You can use any text for the clone voice — make sure it matches the natural recording.',
                'use-website-samples': 'Use the same samples as for the website',
                'go-to-website-samples': 'Go to website samples settings ↓',
                'col-natural': 'Natural Voice',
                'col-clone': 'Clone Voice',
                'label-en': 'English',
                'label-de': 'German',
                'not-supported': 'Your browser does not support the audio tag.',
                'change-audio': 'Change audio',
                remove: 'Remove',
                'drop-or-click': 'Drop an audio file here or click to upload',
                'max-size': 'Max file size: {{maxSize}} MB',
                'file-too-large': 'File is too large. Maximum size is {{maxSize}} MB.',
                'read-error': 'Error reading file'
            },
            demoText: {
                title: 'Demo Text',
                description: 'Enter the text that will be used to generate your clone voice demos.',
                'description-managed': 'The following fixed text is used for your clone voice demos.',
                'label-en': 'English Demo Text',
                'label-de': 'German Demo Text',
                'placeholder-en': 'Enter English text for clone demo generation...',
                'placeholder-de': 'Enter German text for clone demo generation...'
            },
            cloneDemos: {
                'voice-select-label': 'Voice for clone demo generation',
                'voice-link-label': 'Voice for website entry',
                title: 'Clone Voice Demos',
                description: 'Generate demos of your cloned voice. These can be regenerated at any time.',
                'label-en': 'English Clone Demo',
                'label-de': 'German Clone Demo',
                'choose-source': 'Choose how to provide the clone demo.',
                upload: 'Upload clone demo',
                generate: 'Generate',
                regenerate: 'Regenerate',
                generating: 'Generating...',
                delete: 'Delete',
                'keep-current': 'Keep current',
                replace: 'Replace',
                'replace-generated-title': 'Replace generated demo?',
                'replace-generated-description':
                    'Uploading a clone demo will discard the generated preview that has not been saved yet.',
                'replace-upload-title': 'Replace selected upload?',
                'replace-upload-description':
                    'Generating a clone demo will discard the selected upload that has not been saved yet.',
                'no-voice-data': 'Voice data must be configured before clone demos can be generated.',
                'text-required': 'Please enter a demo text before generating.',
                'fixed-demo-text':
                    'With CrispyVoice, you get professional voice actors. Flexible. Legally secure. And exactly when you need it. AI for quick projects, natural voice actors for real emotion.'
            },
            voiceSettings: {
                title: 'Voice Settings',
                description: 'Configure the ElevenLabs voice generation parameters for this voice.',
                speed: 'Speed',
                slower: 'slower',
                faster: 'faster',
                stability: 'Stability',
                'more-variable': 'more variable',
                'more-stable': 'more stable',
                similarity: 'Similarity',
                similarityBoost: 'Similarity Boost',
                style: 'Style',
                'style-exaggeration': 'Style exaggeration',
                none: 'none',
                exaggerated: 'exaggerated',
                'speaker-boost': 'Speaker boost',
                useSpeakerBoost: 'Speaker Boost',
                low: 'low',
                high: 'high',
                'overrides-heading': 'Voice Settings (per generation)'
            },
            currencies: {
                title: 'Supported currencies',
                description: 'Select which currencies you want to offer in your shop',
                'select-at-least-one': 'Please select at least one currency',
                'missing-prices': 'Missing prices for: {{currencies}}. All supported currencies require a price.',
                'cannot-activate':
                    'Cannot activate {{currency}}: {{count}} existing usage(s) do not have a {{currency}} price. Please add {{currency}} prices to all usages first.'
            },
            'speaker-mediums': {
                title: 'Your mediums',
                description:
                    'Define the mediums you want to offer. Mediums describe how your voice can be used (e.g. Commercials, Social Media, etc.).',
                add: 'Add medium',
                save: 'Save',
                saving: 'Saving...',
                delete: 'Delete',
                deleting: 'Deleting...',
                'confirm-delete': 'Really delete this medium?',
                'name-required': 'Name is required',
                'icon-required': 'Please select an icon',
                'name-already-exists': 'A medium with this name already exists',
                'cannot-delete-in-use':
                    'This medium is in use by an allowed usage and cannot be deleted. Remove it from allowed usages first.',
                'cannot-delete-has-purchases': 'This medium has been purchased by customers and cannot be deleted.',
                fields: {
                    name: 'Identifier',
                    'name-placeholder': 'e.g. social-media',
                    icon: 'Icon',
                    'title-en': 'Title (English)',
                    'title-en-placeholder': 'e.g. Social Media',
                    'title-de': 'Title (German)',
                    'title-de-placeholder': 'e.g. Soziale Medien',
                    'examples-en': 'Examples (English)',
                    'examples-en-placeholder': 'e.g. Facebook, YouTube, Instagram',
                    'examples-de': 'Examples (German)',
                    'examples-de-placeholder': 'e.g. Facebook, YouTube, Instagram'
                }
            },
            mediums: {
                title: 'Allowed usages',
                description: 'The usages your clients can choose from',
                'manage-mediums-link': 'Manage your mediums →',
                edit: 'Edit',
                add: 'Add new',
                save: 'Save',
                saving: 'Saving...',
                delete: 'Delete',
                deleting: 'Deleting...',
                'base-price-info': '{{prices}} with {{basePriceCharacters}} included characters',
                restricted: 'Restricted to',
                characters: 'characters',
                fields: {
                    medium: {
                        title: 'Medium',
                        placeholder: 'Select medium',
                        explanations: {
                            short: '',
                            long: ''
                        }
                    },
                    'price-chf': {
                        title: 'Price CHF',
                        placeholder: '',
                        explanations: {
                            short: 'Leave empty if not offered in CHF',
                            long: ''
                        }
                    },
                    'price-eur': {
                        title: 'Price EUR',
                        placeholder: '',
                        explanations: {
                            short: 'Leave empty if not offered in EUR',
                            long: ''
                        }
                    },
                    'price-usd': {
                        title: 'Price USD',
                        placeholder: '',
                        explanations: {
                            short: 'Leave empty if not offered in USD',
                            long: ''
                        }
                    },
                    'base-price-characters': {
                        title: 'Base price characters',
                        placeholder: 'Characters',
                        explanations: {
                            short: 'The characters included in the base price',
                            long: 'Additional characters will be billed linearly'
                        }
                    },
                    'restrict-usage-time': {
                        title: 'Restrict usage time',
                        explanations: {
                            short: 'Restrict usage to a certain timeframe',
                            long: ''
                        }
                    },
                    'timeframe-unit': {
                        title: 'Timeframe',
                        placeholder: 'Select timeframe',
                        explanations: {
                            short: 'The timeframe to restrict to',
                            long: ''
                        }
                    },
                    'timeframe-value': {
                        title: 'Length',
                        placeholder: 'Restriction length',
                        explanations: {
                            short: 'The timeframe to restrict to',
                            long: ''
                        }
                    }
                }
            },
            testimonials: {
                title: 'Testimonials',
                description: 'The testimonials your clients can see',
                edit: 'Edit',
                add: 'Add new',
                delete: 'Delete'
            },
            imprint: {
                title: 'Imprint',
                description: 'The imprint of your shop. This is required by law in many countries.',
                'privacy-mode': {
                    title: 'Privacy Mode',
                    description:
                        'Hide your real name and address from non-customers. When enabled, only the CrispyVoice platform imprint will be shown on your shop. Your personal details will only appear in the release document provided to paying customers.',
                    'active-notice':
                        'Privacy mode is active — your name and address are hidden from the public shop page.'
                },
                'privacy-active-title': 'Privacy mode is active',
                'privacy-active-description':
                    'Your name and address will only be shown in the release document provided to customers after purchase. They will not appear anywhere on your public shop.',
                'privacy-hint':
                    'Want to stay anonymous? You can enable Privacy Mode above to hide your identity from non-customers.',
                address: {
                    'legal-name': 'Legal name',
                    street: 'Street',
                    zipcode: 'Zip code',
                    city: 'City',
                    country: 'Country'
                }
            },
            classifier: {
                title: 'Classifier restrictions',
                description: 'Restrictions on the classifier',
                add: 'Add new restriction',
                delete: 'Delete restriction',
                save: 'Save restriction',
                placeholder: 'Enter restriction...',
                text: 'Text'
            },
            'classifier-test': {
                title: 'Test Classifier',
                description:
                    'Test your classifier restrictions by entering text to see if it would be allowed or blocked.',
                placeholder: 'Enter text to test...',
                button: 'Test Text',
                result: {
                    allowed: '✅ ALLOWED',
                    blocked: '❌ BLOCKED',
                    confidence: 'Confidence:',
                    'triggered-by': 'Blocked by restriction:',
                    'no-restrictions': 'No restrictions configured. Add some restrictions above to test.'
                }
            },
            links: {
                title: 'Links',
                description: 'Links to your social media profiles, website, etc. These will be displayed in your shop.',
                add: 'Add new link',
                delete: 'Delete link',
                save: 'Save link',
                url: 'Url',
                type: {
                    xing: 'Xing',
                    'linked-in': 'LinkedIn',
                    facebook: 'Facebook',
                    instagram: 'Instagram',
                    homepage: 'Homepage',
                    youtube: 'YouTube',
                    tiktok: 'TikTok',
                    other: 'Other'
                }
            },
            'preview-shop': {
                title: 'Preview and release shop',
                description: 'The shop preview can be viewed only by you.',
                open: 'Open shop preview',
                'missing-data-description':
                    'The following info is still missing before we can create your shop. Please fill out the corresponding sections above and don\'t forget to hit the "Save" button.',
                'clone-not-ready':
                    "Great! You've provided all relevant info for the shop. Now, only the clone of your voice is missing to create your live shop.",
                'unreleased-changes': "You can preview the changes you've made in the shop preview here:",
                'no-unreleased-changes': "Looks like you've already released all changes to the live shop. Good job!",
                release: {
                    description:
                        "Once you are satisfied with the changes you've made, you can release them to the live version of your shop by clicking the following button:",
                    button: 'Release changes to live shop'
                },
                'live-shop-description': 'You can also open your current live shop here:',
                'show-live-shop': 'Open live shop'
            },
            'shop-status': {
                title: 'Your shop',
                description:
                    'Your shop is automatically published once all required information is filled in. Changes are visible immediately.',
                live: 'Your shop is live! Changes you save are visible immediately.',
                'open-shop': 'Open your shop',
                'not-live-yet':
                    'Your shop is not live yet. Complete the required settings below to publish it automatically.',
                'not-live-voice-id-missing':
                    'Your shop is not live yet. We are still working on your voice clone. Your shop will go live automatically as soon as we have finished producing it.',
                'missing-data': 'The following information is still missing:'
            }
        },
        'already-in-use': 'This slug is already in use',
        'subdomain-reserved': 'This subdomain is reserved and cannot be used',
        save: 'Save',
        saving: 'Saving...',
        'save-successful': 'Changes saved successfully',
        'form-dirty': "You've unsaved changes",
        required: 'Required',
        'required-settings-heading': 'Required Settings',
        'optional-settings-heading': 'Optional Settings',
        'website-settings-heading': 'Website — Voice Artists Page',
        'website-settings-propagation-note': 'Changes made here may take up to 5 minutes to appear on the website.',
        'website-prerequisites-met-en': 'Your voice is shown on the <0>English website</0>.',
        'website-prerequisites-met-de': 'Your voice is shown on the <0>German website</0>.',
        'website-prerequisites-not-met-en': 'Your voice is not shown on the <0>English website</0>. Missing:',
        'website-prerequisites-not-met-de': 'Your voice is not shown on the <0>German website</0>. Missing:',
        'website-prerequisites-description-en': 'Voice description (English)',
        'website-prerequisites-description-de': 'Voice description (Deutsch)',
        'website-prerequisites-sample-en': 'Website audio sample (English)',
        'website-prerequisites-sample-de': 'Website audio sample (Deutsch)',
        countries: shopSettingsCountries
    },
    onboarding: {
        emails: {
            welcome: {
                subject: 'Welcome to CrispyVoice!',
                heading: 'Welcome to CrispyVoice, {{user_name}}!',
                login: 'Login here',
                intro:
                    'Thanks for placing your trust in us. We look forward to helping you stay competitive in an AI-driven world.',
                uploadPrefix: 'You can upload the audio data for your voice clone here:',
                uploadLinkLabel: 'Click here',
                uploadSuffix: 'Do not forget to confirm your uploaded audio data afterwards.',
                stepsHeading: 'Here is what happens next:',
                stepUpload: 'Upload your audio files',
                stepRelax: 'Lean back and relax',
                stepStatus:
                    'We will let you know as soon as your clone is ready. You can check the current status in your account at any time.',
                documentsHeading: 'Important documents are available here:',
                invoiceLinkLabel: 'Your invoice',
                termsLinkLabel: 'Our terms and conditions',
                privacyLinkLabel: 'Privacy policy',
                credentialsNotice:
                    'You already received your login details in a separate email. Please remember to change your password.',
                support: 'If you need help along the way, just reply by email or give us a call.',
                signoff: 'Greetings from Switzerland',
                team: 'Your CrispyVoice team'
            },
            password: {
                subject: 'CrispyVoice: Your Account Password',
                heading: 'CrispyVoice account password',
                'password-text': "Here's your initial account password:",
                login: 'Login here',
                'change-it': 'We highly suggest that you change it after the initial login.',
                greeting: 'Ahoy!',
                credentialsIntro: 'Here are the login credentials for your CrispyVoice account:',
                usernameLabel: 'Username:',
                initialPasswordLabel: 'Initial password:',
                importantHeading: 'Important:',
                loginPrefix: 'Log in here:',
                helpHeading: 'Need help?',
                helpPrefix: 'Take a look at our',
                helpLinkLabel: 'FAQ',
                helpSuffix: 'or contact our crew directly.',
                signoff: 'Greetings from Switzerland',
                team: 'Your CrispyVoice team'
            },
            newSpeakerRegistration: {
                subject: 'New speaker has just registered!'
            }
        }
    },
    buyers: {
        heading: 'Buyers',
        'no-buyers': 'You do not have any buyers yet.',
        'no-buyers-description':
            'Promote your CrispyVoice and sell it to your fans! Once you have sales, your buyers will be displayed here.',
        'buyer-name': 'Name',
        'buyer-email': 'Email',
        'buyer-phoneNumber': 'PhoneNumber',
        'buyer-city': 'City',
        'buyer-number-of-sales': 'Number Of Sales',
        'buyer-total-sales-volume': 'Total Sales Volume',
        details: {
            heading: 'Buyer: {{buyerName}}'
        }
    },
    sales: {
        heading: 'Sales',
        'no-sales': 'You do not have any sales yet.',
        'no-sales-description':
            'Promote your CrispyVoice and sell it to your fans! Once you have sales, they will appear here.',
        sales: {
            heading: 'Sale: {{buyerName}} / {{date}}'
        }
    },
    affiliate: {
        heading: 'CrispyAffiliate',
        description: 'Earn commissions from voice artists who sign up through your personal affiliate link.',
        'your-link': 'Your Affiliate Link',
        'copy-link': 'Copy Link',
        'link-copied': 'Copied!',
        'your-terms': 'Your Commission Terms',
        'no-touch-heading': 'No-Touch Sale',
        'assisted-heading': 'Assisted Sale',
        'sale-rate': 'Sale Commission',
        'sale-duration': 'Sale Duration',
        'monthly-fee-rate': 'Monthly Fee Commission',
        'monthly-fee-duration': 'Monthly Fee Duration',
        months: 'months',
        unlimited: 'unlimited',
        rate: 'Rate',
        'no-touch-rate': 'No-Touch Rate',
        'assisted-rate': 'Assisted Rate',
        duration: 'Duration',
        'referrals-heading': 'Referred Voice Artists',
        'no-referrals': 'No referrals yet. Share your affiliate link to start earning!',
        'sale-type-heading': 'Commission Type',
        'sale-type-self-service': 'Active Marketing',
        'sale-type-assisted': 'Basic Referral',
        'sale-type-pending': 'Pending',
        'sale-type-self-service-tooltip': 'You actively worked with this person – we did not need to have a call.',
        'sale-type-assisted-tooltip': 'This person signed up through your link and we had a call with them.',
        'sale-type-pending-tooltip':
            'The commission type has not been determined yet. Revenue will be counted once classified.',
        'pending-classification': 'pending classification',
        'pending-note':
            '{{count}} referral(s) are still pending classification. Their revenue is not included in the totals above until the commission type is determined.',
        'cv-sales-revenue': 'CrispyVoice Sales Revenue',
        'sales-commission': 'Sales Commission',
        'monthly-fee-commission': 'Monthly Fee Commission',
        'total-commission': 'Total Commission',
        'transfer-desc-audio-sale': 'Commission – audio sale by {{name}} ({{percent}}%)',
        'transfer-desc-subscription': 'Commission – subscription by {{name}} ({{percent}}%)',
        'contract-type': 'Contract Type',
        status: 'Status',
        'status-active': 'Active',
        'status-past_due': 'Past Due',
        'status-canceled': 'Canceled',
        'status-unknown': 'Unknown',
        'signed-up': 'Signed up',
        total: 'Total',
        'bonus-heading': 'Milestone Bonuses',
        'bonus-description':
            'Earn one-time bonuses by reaching referral milestones. Qualifying referrals: Core/Basic accounts with yearly billing and an active subscription.',
        'bonus-qualifying-count': 'Qualifying referrals',
        'bonus-referrals': 'referrals',
        'bonus-total-earned': 'Milestone bonuses earned',
        'campaigns-heading': 'Ambassador Campaigns',
        'campaign-label': 'Campaign:',
        'campaign-codes-left': '{{count}} codes left',
        'campaign-no-codes': 'No unused invite codes',
        'campaign-copy-code': 'Click to copy link',
        'campaign-discount': 'Discount',
        'campaign-redeemed': '{{count}} redeemed',
        'campaign-outstanding': '{{count}} outstanding',
        'campaign-remaining': '{{count}} remaining',
        'campaign-all-redeemed': 'All invite codes have been redeemed.',
        'campaign-get-next': 'Copy next invite link ({{remaining}} remaining)',
        'campaign-link-copied': 'Link copied!',
        'campaign-loading': 'Getting link...',
        'campaign-show-history': 'Show sent links ({{count}})',
        'campaign-hide-history': 'Hide sent links',
        'campaign-status-redeemed': 'Redeemed',
        'campaign-status-open': 'Open',
        'campaign-status-invalidated': 'Invalidated'
    },
    voices: {
        heading: 'My Voices',
        description: 'Manage your voice clones. Each voice can have its own shop, recordings, and settings.',
        'voice-count': '{{count}} of {{max}} voices',
        'add-voice': 'Add Voice',
        'voice-label': 'Voice {{index}}',
        'status-ready': 'Ready',
        'status-pending': 'Pending',
        'status-archived': 'Archived',
        delete: 'Delete',
        archive: 'Archive',
        unarchive: 'Unarchive',
        'archived-heading': 'Archived Voices',
        'set-voice-id': 'Set Voice ID',
        'change-voice-id': 'Change Voice ID',
        'col-name': 'Name',
        'col-slug': 'Slug',
        'col-voice-id': 'Voice ID',
        'col-status': 'Status',
        'create-modal': {
            title: 'Add New Voice',
            'name-label': 'Voice Name',
            'name-placeholder': 'e.g. My German Voice',
            'copy-from-label': 'Copy settings from',
            'copy-from-none': 'Start fresh',
            'copy-from-description': 'Copies pricing, links, restrictions, and testimonials from the selected voice.',
            'voice-id-label': 'ElevenLabs Voice ID',
            'voice-id-description': 'Optionally set the ElevenLabs Voice ID now, or add it later.',
            submit: 'Create Voice'
        },
        'delete-modal': {
            title: 'Delete Voice',
            description:
                'Are you sure you want to delete this voice? This will permanently remove all associated recordings and shop data. This action cannot be undone.',
            confirm: 'Delete Voice'
        },
        'archive-modal': {
            title: 'Archive Voice',
            description:
                'Archiving this voice will deactivate its shop. The voice and its sold recordings will be preserved, but it will no longer be publicly available. Archived voices do not count towards your voice limit.',
            confirm: 'Archive Voice'
        },
        'voice-id-modal': {
            title: 'Set ElevenLabs Voice ID',
            label: 'ElevenLabs Voice ID',
            placeholder: 'e.g. bqnMEfPMfAsV6leYpGPD',
            description:
                'Enter the Voice ID from your ElevenLabs account. You can find it in the ElevenLabs voice settings.',
            submit: 'Save Voice ID'
        },
        'test-voice': {
            label: 'Test Voice',
            placeholder: 'Enter text to test (max 100 characters)',
            test: 'Test',
            testing: 'Testing…'
        }
    },
    'speaker-settings': {
        heading: 'Speaker Settings',
        subheading: 'Manage your global speaker settings. These apply across all your voices.',
        sections: {
            'speaker-mediums': {
                title: 'Your mediums',
                description:
                    'Define the mediums you want to offer. Mediums describe how your voice can be used (e.g. Commercials, Social Media, etc.).',
                'name-required': 'Name is required',
                'icon-required': 'Please select an icon',
                'name-already-exists': 'A medium with this name already exists',
                'cannot-delete-in-use':
                    'This medium is in use by an allowed usage and cannot be deleted. Remove it from allowed usages first.',
                'cannot-delete-has-purchases': 'This medium has been purchased by customers and cannot be deleted.'
            },
            'shop-mode': {
                title: 'Shop Mode',
                description: 'How are your voices related? This setting is permanent and cannot be changed later.',
                'locked-title': 'Shop mode is configured',
                'current-single':
                    'Your shop is configured for one person with multiple voice styles and is available at:',
                'current-separate': 'Your shop is configured for multiple persons or personas.',
                'separate-title': 'Multiple Persons / Personas',
                'separate-description':
                    'Choose this if your voices represent different people or completely separate personas. Each voice gets its own subdomain (e.g. voice-name.crispyvoice.com).',
                'single-title': 'One Person, Multiple Styles',
                'single-description':
                    'Choose this if one person offers multiple voice styles (e.g. corporate, enthusiastic, narrative). All voices are grouped under a single subdomain (e.g. my-shop.crispyvoice.com/voice-name).',
                'slug-label': 'Shop subdomain',
                'slug-placeholder': 'my-shop',
                'slug-preview': 'Your shop will be available at {{shopHost}}',
                'slug-min-length': 'Must be at least 3 characters',
                'slug-format': 'Must start with a letter and contain only lowercase letters, numbers and hyphens',
                'slug-required': 'A subdomain slug is required for single subdomain mode',
                'slug-taken': 'This slug is already taken',
                'slug-reserved': 'This subdomain is reserved and cannot be used',
                'already-configured': 'Shop mode has already been configured and cannot be changed',
                'lock-warning': 'Warning: This setting is permanent. Once saved, you cannot switch between modes.',
                save: 'Save Shop Mode',
                'display-name-title': 'Display Name',
                'display-name-description': 'The name shown publicly on your shop.',
                'display-name-placeholder': 'Your name or brand',
                'display-name-required': 'Display name is required'
            },
            'unified-shop': {
                title: 'Single-page shop (beta)',
                description:
                    'Instead of the voice overview, show a single shop page with a voicing selector and inline checkout for all of your voices. When enabled, the per-voice URL (sub-path) setting is hidden in shop settings.',
                enabled: 'Single-page shop enabled',
                disabled: 'Single-page shop disabled'
            },
            'shared-shop': {
                'select-at-least-one-currency': 'Select at least one currency.'
            },
            'shop-description': {
                title: 'Shop description',
                description:
                    'Describe your voice offer for the Unified Shop. This text is separate from your website profile.',
                english: 'English',
                german: 'German',
                save: 'Save description',
                saved: 'Description saved',
                unsaved: 'You have unsaved changes.'
            },
            imprint: {
                title: 'Imprint',
                description: 'The imprint of your shop. This is required by law in many countries.',
                'privacy-mode': {
                    title: 'Privacy Mode',
                    description:
                        'Hide your real name and address from non-customers. When enabled, only the CrispyVoice platform imprint will be shown on your shop. Your personal details will only appear in the release document provided to paying customers.',
                    'active-notice':
                        'Privacy mode is active — your name and address are hidden from the public shop page.'
                },
                'privacy-active-title': 'Privacy mode is active',
                'privacy-active-description':
                    'Your name and address will only be shown in the release document provided to customers after purchase. They will not appear anywhere on your public shop.',
                'privacy-hint':
                    'Want to stay anonymous? You can enable Privacy Mode above to hide your identity from non-customers.',
                address: {
                    'legal-name': 'Legal name',
                    street: 'Street',
                    zipcode: 'Zip code',
                    city: 'City',
                    country: 'Country'
                }
            }
        },
        save: 'Save',
        'save-successful': 'Changes saved successfully',
        'form-dirty': "You've unsaved changes"
    }
};
